import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../assets/styles/style.css'; 
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import TopBar from './TopBar';
import axios from 'axios';
import { API_URL } from '../variables';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };

    const handleScroll = () => {
      const header = document.querySelector('header');
      const topBar = document.querySelector('.top-bar');
      
      if (window.scrollY > topBar.offsetHeight) {
        header.style.top = '0';
      } else {
        header.style.top = '40px';
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Fetch destinations for the dropdown
  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        const response = await axios.get(`${API_URL}/destination/getAllDestinations`);
        setDestinations(response.data);
      } catch (error) {
        console.error('Error fetching destinations:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDestinations();
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleDestinationClick = (destinationName) => {
    navigate('/tours', { 
      state: { selectedDestination: destinationName } 
    });
    setMenuOpen(false);
  };

  const toggleDropdown = (e) => {
    if (window.innerWidth <= 768) {
      e.preventDefault();
      setDropdownOpen(!dropdownOpen);
    }
  };

  return (
    <>
      <TopBar />
      <header className={isHomePage ? 'home-header' : ''}>
        <nav>
          <div className="logo">
            <Link to="/">
              {isMobile && (
                <img 
                  src={`${process.env.PUBLIC_URL}/tourslogo.png`}
                  alt="Song & Stark Tours Logo"
                  className="logo-image"
                />
              )}
              <span className="logo-text">SONG & STARK TOURS</span>
            </Link>
          </div>
          <button 
            className={`menuToggleBtn ${menuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/tours">Tour Packages</Link></li>
            <li className={`dropdown ${dropdownOpen ? 'open' : ''}`}>
              <Link 
                to="#" 
                onClick={toggleDropdown} 
                style={{ cursor: 'pointer' }}
              >
                Destinations <FaChevronDown style={{ fontSize: '12px', marginLeft: '4px' }} />
              </Link>
              <div className="dropdown-content">
                {loading ? (
                  <div style={{ padding: '10px', textAlign: 'center' }}>Loading...</div>
                ) : (
                  destinations.map((destination) => (
                    <span className="a"
                      key={destination.id}
                      onClick={() => handleDestinationClick(destination.destination_name)}
                    >
                      {destination.destination_name}
                    </span>
                  ))
                )}
              </div>
            </li>
            <li><Link to="/about">About Us</Link></li>
            <li className="btn-yellow"><Link to="/plan-trip">Plan Your Trip</Link></li>
            <li className="btn-green"><Link to="/contact">Contact Us</Link></li>
          </ul>
        </nav>
      </header>
    </>
  );
}

export default Header;